import type { ReactNode } from 'react'

import { StatusBadgeStyled } from './styles/StatusBadgeStyled'
import { Icon, type IconTypes } from '../Icon'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'
import { type Enum } from '@ui/utils/enums'

export const StatusBadgeStatuses = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INACTIVE: 'inactive',
  INCOMPLETE: 'incomplete',
  IN_PROGRESS: 'inProgress',
} as const

export type StatusBadgeStatus = Enum<typeof StatusBadgeStatuses>

export interface IStatusBadgeProps {
  /**
   * Unique identifier for analytics tracking.
   */
  analyticsId?: string
  type: StatusBadgeStatus
  text: string
  icon?: IconTypes
  iconComponent?: ReactNode
  paddingSize?: 'small' | 'medium'
  'aria-label'?: string
}

export const StatusBadge = ({
  analyticsId,
  type,
  text,
  icon,
  iconComponent,
  paddingSize = 'medium',
  'aria-label': ariaLabel,
}: IStatusBadgeProps) => {
  const analyticsProps = getAnalyticsDataAttrs(analyticsId)
  const hasIcon = !!icon || !!iconComponent
  const fontSize = paddingSize === 'small' ? 12 : 14

  return (
    <StatusBadgeStyled
      type={type}
      fontSize={fontSize}
      paddingSize={paddingSize}
      hasIcon={hasIcon}
      aria-label={ariaLabel}
      {...analyticsProps}
    >
      {!!iconComponent && iconComponent}

      {!!icon && <Icon icon={icon} />}

      <span>{text}</span>
    </StatusBadgeStyled>
  )
}
